export default __webpack_public_path__ + "static/media/typeboat.adb5bb37.svg";